export const describeValue = (value: unknown): string => {
  if (value === null) return 'null';
  if (value === undefined) return 'undefined';

  if (Array.isArray(value)) {
    return `lista com ${value.length} item(ns)`;
  }

  if (typeof value === 'object') {
    const keys = Object.keys(value as object);
    return keys.length
      ? `objeto com as chaves: ${keys.join(', ')}`
      : 'objeto vazio';
  }

  return `${typeof value} (${String(value)})`;
};

/**
 * Normalizes API/redux list payloads into arrays.
 * Accepts plain arrays or common paginated shapes ({ items }, { data }).
 * Throws a clear Error when the value exists but is not a list.
 */
export const toArray = <T>(value: unknown, label: string): T[] => {
  if (value === null || value === undefined) {
    return [];
  }

  if (Array.isArray(value)) {
    return value as T[];
  }

  if (typeof value === 'object') {
    const obj = value as Record<string, unknown>;

    if (Array.isArray(obj.items)) {
      return obj.items as T[];
    }

    if (Array.isArray(obj.data)) {
      return obj.data as T[];
    }
  }

  throw new Error(
    `${label} deveria ser uma lista (array), mas a aplicação recebeu ${describeValue(
      value
    )}. Informação esperada: lista de ${label.toLowerCase()}. Verifique o formato da resposta da API.`
  );
};

export default toArray;
